import React, {useRef} from "react";
import {useForm} from "react-hook-form";
import {ResetPassword} from "./AskNewPasswordTypes";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../app/RootReducer";
import {GetCurrentLocale, GetUrlParams} from "../../../components/Utils";
import {SpinnerOnTop} from "../../../components/SpinnerOnTop";
import {GetPasswordRegex} from "../../../components/UtilsForFormValidation";
import {userSetNewPasswordRequest} from "../UsersSlice";
import t, {changeLanguage} from "../../../components/I18N/TranslateHelpers";
const ResetPasswordFormContainer = () => {
  const dispatch = useDispatch();
  const isRequesting = useSelector((state: RootState) => state.userRdc.isRequestingNewPassword);
  const success = useSelector((state: RootState) => state.userRdc.isRequestingNewPasswordSuccess);
  const error = useSelector((state: RootState) => state.userRdc.error);
  const params = GetUrlParams();

  const passwordResetToken = params['token'];

  const { register, handleSubmit, watch, formState: { errors } } =  useForm<ResetPassword>();
  const password = useRef({});
  password.current = watch("password", "");

  const onSubmit = (data: ResetPassword) =>
  {
    // alert(JSON.stringify(data));
    dispatch(userSetNewPasswordRequest(data, passwordResetToken));
  }

  const locale = GetCurrentLocale();
  changeLanguage(locale)

  return(
    isRequesting ?
      <div className="py-5">
        <SpinnerOnTop/>
      </div>
      :
      success ?
        <>
          <div className="alert alert-success" role="alert">
            {t('reset_password_success')}
          </div>
          <a href={ "/" + locale + t('url_login')} className="button button-rounded m-0 center">
            { t("login")}
          </a>
        </>
        :
        error ?
          <div className="alert alert-danger" role="alert">{t('error')} {error.message}</div>
          :
          passwordResetToken ?
            <form action="#" className="login-signup-form" onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="mb-3">
                  <label className="form-label">
                    {t('password')}
                  </label>
                    <input type="password"
                           className="form-control"
                           id="password"
                           placeholder="●●●●●●●●"
                           {...register("password",
                             {
                               required: true,
                               pattern: GetPasswordRegex(),
                             }
                           )}
                    />
                    {errors.password ? errors.password.type === 'pattern' ?
                      <span className="field-required-password">{t("conditions_pwd")}</span> :
                      <span className="field-required">{t("fields_required")}</span> : null}
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    {t('confirm_password')}
                  </label>
                    <input type="password"
                           className="form-control"
                           id="passwordConfirm"
                           placeholder="●●●●●●●●"
                           {...register("passwordConfirm",
                             {
                               required : true,
                               validate: value =>
                                 value === password.current || "The passwords do not match"
                             })}
                    />
                    {errors.passwordConfirm ? errors.passwordConfirm.type === 'validate' ?
                      <span className="field-required">{t("password_no_match")}</span> :
                      <span className="field-required">{t("fields_required")}</span> : null}
                </div>
                <div className="col-md-12 align-items-center">
                  <button className="btn btn-primary width100" type="submit">
                    { t("change_password")}
                  </button>
                </div>
              </div>
            </form>
            :
            <div className="alert alert-danger" role="alert">
              {t('invalid_token')}
            </div>
  )
}

export default ResetPasswordFormContainer;
